import './utils/apiInterceptor'; // Initialize Global Interceptor
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import ScoreCalculator from './components/Tools/ScoreCalculator/ScoreCalculator';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Initialize i18n
import CharacterData from './components/Characters/CharacterData';
import CharactersOriginal from './CharactersOriginal';

import CharactersSupport from './CharactersSupport';
import SupportDetail from './components/supports/SupportDetail';
import SupportEdit from './components/supports/edit/SupportEdit';
import SupportEditPage from './components/supports/edit/SupportEditPage';
import SupportComparator from './components/Tools/Comparator/SupportComparator';
import SkillAnalyzer from './components/Tools/SkillAnalyzer/SkillAnalyzer';
import RacePlanner from './components/Tools/RacePlanner/RacePlanner';
import Skills from './Skills';
import SkillDetail from './components/Skills/SkillDetail/SkillDetail';
import Login from './Login';
import Welcome from './Welcome'; // Temporary Landing Page
import Register from './Register';
import RequestPassChange from './components/Login/RequestPassChange';
import ResetPassword from './components/Login/ResetPassword';
import MainLayout from './components/shared/MainLayout'; // Layout Compartido
import User from './User';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import RaceList from './components/races/RaceList';
import RaceDetail from './components/races/RaceDetail/RaceDetail';
import MiniGamesHub from './components/MiniGames/MiniGamesHub'; // NEW
import About from './About';


import { HelmetProvider } from 'react-helmet-async';
import { ROUTES } from './routes'; // Import ROUTES

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Autosuficientes (Sin Header/Footer externo o con lógica propia) */}
              <Route path="/" element={<Navigate to={ROUTES.MAIN} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<RequestPassChange />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path={ROUTES.TOOLS_SCORE} element={<ScoreCalculator />} /> {/* ScoreCalculator con su propio layout */}

              {/* Rutas con Layout Principal (Header + Footer) */}
              <Route element={<MainLayout />}>
                <Route path={ROUTES.MAIN} element={<Welcome />} />
                <Route path={ROUTES.ABOUT} element={<About />} />

                {/* Tools */}
                <Route path={ROUTES.TOOLS_SUPPORT} element={<SupportComparator />} />
                <Route path={ROUTES.TOOLS_SKILL_ANALYZER} element={<SkillAnalyzer />} />
                <Route path={ROUTES.TOOLS_RACE_PLANNER} element={<RacePlanner />} />

                {/* Rutas de Characters */}
                <Route path="/characters" element={<Navigate to={ROUTES.CHARACTERS_ORIGINAL} replace />} />
                <Route path={ROUTES.CHARACTERS_ORIGINAL} element={<CharactersOriginal />} />

                <Route path={ROUTES.CHARACTERS_SUPPORT} element={<CharactersSupport />} />
                <Route path={`${ROUTES.CHARACTERS_SUPPORT}/edit`} element={<SupportEdit />} />
                <Route path={`${ROUTES.CHARACTERS_SUPPORT}/:id/edit`} element={<SupportEditPage />} />
                <Route path={`${ROUTES.CHARACTERS_SUPPORT}/:id`} element={<SupportDetail />} />

                {/* Rutas de Admin */}
                <Route path={ROUTES.CHARACTER} element={<Navigate to={ROUTES.CHARACTERS_ORIGINAL} replace />} />
                <Route path={`${ROUTES.CHARACTER}/new`} element={<CharactersOriginal />} />
                <Route path={`${ROUTES.CHARACTER}/:id/edit`} element={<CharactersOriginal />} />

                {/* Rutas Dinámicas */}
                <Route path={`${ROUTES.CHARACTER}/:characterName`} element={<CharacterData />} />

                {/* Skills */}
                <Route path={ROUTES.SKILLS} element={<Skills />} />
                <Route path={`${ROUTES.SKILL_DETAIL}/:id_skill`} element={<SkillDetail />} />

                {/* User */}
                <Route path={`${ROUTES.USER}/profile`} element={<User />} />
                <Route path={`${ROUTES.USER}/settings`} element={<User />} />
                <Route path={`${ROUTES.USER}/admin`} element={<User />} />
                <Route path={ROUTES.WEBHOOKS} element={<User />} />

                {/* Races */}
                <Route path={ROUTES.RACES} element={<RaceList />} />
                <Route path={`${ROUTES.RACE}/:id`} element={<RaceDetail />} />

                {/* MiniGames - Supports Nested Routes */}
                <Route path={`${ROUTES.MINIGAMES}/*`} element={<MiniGamesHub />} />

              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
// Revisado: 2025-12-16
